export default __webpack_public_path__ + "static/media/heart-inside-circle.c50665be.svg";